import { render, staticRenderFns } from "./QuestionCheckPointEdit.vue?vue&type=template&id=052de608&"
import script from "./QuestionCheckPointEdit.vue?vue&type=script&lang=js&"
export * from "./QuestionCheckPointEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports